import { createBrowserRouter } from "react-router-dom";
import LandingPage from "../views/LandingPage";
import Login from "../views/auth/Login";
import Signup from "../views/auth/Signup";
import App from "../views/app/App";
import ProtectedRoute from "../views/auth/ProtectedRoute";
import Dashboard from "../views/app/Dashboard";
import MyApps from "../views/app/MyApps";
import OtherLinks from "../views/app/OtherLinks";
import Docs from "../views/Docs";
import AppDashboard from "../views/app/appDashboard/AppDashboard";
import AdminProtected from "../views/auth/AdminProtected";
import Analytics from "../views/admin/Analytics";
import MyLinks from "../views/app/MyLinks";
import PayViaLinkPage from "../views/PayViaLinkPage";
import Invoices from "../views/app/Invoices";
import MyInvoices from "../views/app/MyInvoices";
import CreateInvoice from "../views/app/CreateInvoice";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/docs",
    element: <Docs />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <App />,
        children: [
          {
            path: "/dashboard",
            element: <Dashboard />,
          },
          {
            path: "/my-apps",
            element: <MyApps />,
          },
          {
            path: "/my-links",
            element: <MyLinks />,
          },
          {
            path: "/app-dashboard/:id",
            element: <AppDashboard />,
          },
          {
            element: <Invoices />,
            children: [
              {
                path: "/invoices",
                element: <MyInvoices />,
              },
              {
                path: "/invoices/create",
                element: <CreateInvoice />,
              },
            ],
          },
          {
            path: "other-links",
            element: <OtherLinks />,
          },
        ],
      },
    ],
  },
  //admin
  {
    element: <AdminProtected />,
    children: [
      {
        element: <App />,
        children: [
          {
            path: "/admin-analytics",
            element: <Analytics />,
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/link/:slug",
    element: <PayViaLinkPage />,
  },
]);
